export var PrivacyType;
(function (PrivacyType) {
    PrivacyType[PrivacyType["Public"] = 1] = "Public";
    PrivacyType[PrivacyType["Community"] = 2] = "Community";
    PrivacyType[PrivacyType["Members"] = 4] = "Members";
    PrivacyType[PrivacyType["Private"] = 5] = "Private";
    PrivacyType[PrivacyType["Participants"] = 6] = "Participants";
})(PrivacyType || (PrivacyType = {}));
//# sourceMappingURL=PrivacyType.js.map